// not being used as of now
// export const getImageUrl = (
//     msid,
//     imgSize,
//     imgWidth,
//     imgHeight,
//     imgMode = '4'
// ) => {
//     if (!msid) {
//         return ''
//     }
//     const imageURL = `${IMG_DOMAIN}/thumb/resizemode-${imgMode},msid-${msid}${
//         imgSize ? `,imgsize-${imgSize}` : ''
//     }${imgWidth ? `,width-${imgWidth}` : ''}${
//         imgHeight ? `,height-${imgHeight}` : ''
//     }/${msid}.jpg`

//     return imageURL
// }

// eslint-disable-next-line import/prefer-default-export
export const removeUnsupportedCharacters = (str) =>
  // supported
  // 0-9,
  // a-z,
  // <white space>,
  // hyphen,
  // underscore
  (str || '').replace(/[^0-9a-z\s_-]/gi, '')
